/* import { faBullhorn } from "@fortawesome/free-solid-svg-icons"; */
import { faAward } from "@fortawesome/free-solid-svg-icons";
import { REWARDS_ENABLED } from "./helpers/rewardsEnabled";

export const homeRoutes = {
  name: "Inicio",
  to: "/dashboard/app",
  exact: true,
  iconsrc: "Icono Inicio 2.png",
};

export const condominiumRoutes = {
  to: "/dashboard/condominiums",
  name: "Condominios",
  iconsrc: "Icono Condominio 2.png",
};

export const pageRoutes = {
  name: "Administración",
  iconsrc: "Icono Administracion 2.png",
  // HO-HU-36: este grupo concentra todos los modulos con los que trabaja un
  // manager, y hasta ahora arrancaba colapsado -- un usuario nuevo entraba y
  // solo veia "Inicio / Condominios / Soporte". Arranca desplegado (ver
  // NavbarVerticalMenu) para que los modulos esten a la vista sin tener que
  // descubrir el acordeon.
  defaultOpen: true,
  children: [
    { to: "/dashboard/banks", name: "Bancos", iconsrc: "Icono Bancos 2.png" },
    {
      to: "/dashboard/exchange",
      name: "Tasas de cambio",
      iconsrc: "Icono Finanzas 2.png",
    },
    {
      to: "/dashboard/periods",
      name: "Períodos",
      iconsrc: "Icono Bancos 2.png",
    },
    // Contabilidad ya no tiene entrada propia: es una pestaña de Finanzas.
    {
      to: "/dashboard/finance",
      name: "Finanzas",
      iconsrc: "Icono Finanzas 2.png",
    },
    {
      to: "/dashboard/aliquots",
      name: "Alícuotas",
      iconsrc: "Icono Finanzas 2.png",
    },
    {
      to: "/dashboard/funds",
      name: "Fondos de reserva",
      iconsrc: "Icono Bancos 2.png",
    },
    {
      to: "/dashboard/properties",
      name: "Propiedades",
      iconsrc: "Icono Propiedades 2.png",
    },
    // { to: '/dashboard/feed', name: 'Muro de noticias', icon: faBullhorn },
    {
      to: "/dashboard/providers",
      name: "Proveedores",
      iconsrc: "Icono Proveedores 2.png",
    },
    {
      to: "/dashboard/security",
      name: "Seguridad",
      iconsrc: "Icono Seguridad 2.png",
    },
    {
      to: "/dashboard/visitors",
      name: "Visitantes",
      iconsrc: "Icono Visitantes 2.png",
    },
    {
      to: "/dashboard/areas",
      name: "Areas comunes",
      iconsrc: "Icono Areas Comunes 2.png",
    },
    {
      to: "/dashboard/parking",
      name: "Parqueos",
      iconsrc: "Icono Parqueaderos 2.png",
    },
    {
      to: "/dashboard/surveys",
      name: "Encuestas/Votaciones",
      iconsrc: "Icono Encuestas y votaciones 2.png",
    },
    // HO-TASK-288: sin ícono propio todavía (como en el menú del
    // propietario), se usa el de FontAwesome.
    ...(REWARDS_ENABLED
      ? [
          {
            to: "/dashboard/rewards",
            name: "Homelan Rewards",
            icon: faAward,
          },
        ]
      : []),
    {
      to: "/dashboard/complaints",
      name: "Centro de sugerencias",
      iconsrc: "Icono Centro de quejas 2.png",
    },
    {
      to: "/dashboard/config",
      name: "Configuración",
      iconsrc: "Icono Configuracion 2.png",
    },
  ],
};

export const reportRoutes = {
  name: "Reportes",
  icon: "copy",
  children: [{ to: "/errors", name: "Reportes de ejemplo" }],
};

export const supportRoutes = {
  name: "Soporte",
  iconsrc: "Icono Soporte 2.png",
  to: "/dashboard/support",
};

const managerRoutes = [
  homeRoutes,
  condominiumRoutes,
  pageRoutes,
  supportRoutes,
];

export default managerRoutes;
